import { Field } from "./field";
import { cr } from "fire-wind-water/core";
import api from "../services/api";
import { SURL } from "../../sbase";

/*

上传显示类型大全
显示图片类型
* accept="image/*"

显示xlsx表格文件
application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
显示docx文档文件
application/vnd.openxmlformats-officedocument.wordprocessingml.document

文件后缀	    格式1	                                          格式2
*.3gpp	   audio/3gpp, video/3gpp	                          3GPP Audio/Video
*.ac3	     audio/ac3	                                      AC3 Audio
*.au	     audio/basic	                                    AU Audio
*.mp2	     audio/mpeg, video/mpeg	                          MPEG Audio/Video Stream, Layer II
*.mp3	     audio/mpeg	                                      MPEG Audio Stream, Layer III
*.mp4	     audio/mp4, video/mp4	                            MPEG-4 Audio/Video
*.asf	     allpication/vnd.ms-asf	                          Advanced Streaming Format
*.doc	     application/msword	                              MS Word Document
*.dot	     application/msword	                              MS Word Template
*.dtd	     application/xml-dtd	                            Document Type Definition
*.json	   application/json	                                JavaScript Object Notation
*.mpp	     application/vnd.ms-project	                      MS Project Project
*.ogg	     application/ogg, audio/ogg	                      Ogg Vorbis
*.pdf	     application/pdf	                                Portable Document Format
*.pot	     application/vnd.ms-powerpoint	                  MS PowerPoint Template
*.pps	     application/vnd.ms-powerpoint	                  MS PowerPoint Slideshow
*.ppt	     application/vnd.ms-powerpoint	                  MS PowerPoint Presentation
*.rtf	     application/rtf, text/rtf	                      Rich Text Format
*.wdb	     application/vnd.ms-works	                        MS Works Database
*.wps	     application/vnd.ms-works	                        Works Text Document
*.xhtml	   application/xhtml+xml	                          Extensible HyperText Markup Language
*.xlc	     application/vnd.ms-excel	                        MS Excel Chart
*.xlm	     application/vnd.ms-excel	                        MS Excel Macro
*.xls	     application/vnd.ms-excel	                        MS Excel Spreadsheet
*.xlt	     application/vnd.ms-excel	                        MS Excel Template
*.xlw	     application/vnd.ms-excel	                        MS Excel Workspace
*.zip	     aplication/zip	                                  Compressed Archive
*.dwg	     image/vnd.dwg	                                  AutoCAD Drawing Database
*.dxf	     image/vnd.dxf	                                  AutoCAD Drawing Interchange Format
*.gif	     image/gif	                                      Graphic Interchange Format
*.jp2	     image/jp2	                                      JPEG-2000
*.jpe	     image/jpeg	                                      JPEG
*.jpeg	   image/jpeg	                                      JPEG
*.jpg	     image/jpeg	                                      JPEG
*.png	     image/png	                                      Portable Network Graphics
*.svf	     image/vnd.svf	                                  Simple Vector Format
*.tif	     image/tiff	                                      Tagged Image Format File
*.tiff	   image/tiff	                                      Tagged Image Format File
*.htm	     text/html	                                      HyperText Markup Language
*.html	   text/html	                                      HyperText Markup Language
*.css	     text/css	                                        Cascading Style Sheets
*.csv	     text/csv	                                        Comma Separated Values
*.js	     text/javascript, application/javascript	        JavaScript
*.txt	     text/plain	                                      Plain Text
*.xml	     text/xml, application/xml	                      Extensible Markup Language
*.mpeg	   video/mpeg	                                      MPEG Video Stream, Layer II
*.mpg	     video/mpeg	                                      MPEG Video Stream, Layer II
.xlsx   application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
.xltx   application/vnd.openxmlformats-officedocument.spreadsheetml.template
.potx   application/vnd.openxmlformats-officedocument.presentationml.template
.ppsx   application/vnd.openxmlformats-officedocument.presentationml.slideshow
.pptx   application/vnd.openxmlformats-officedocument.presentationml.presentation
.sldx   application/vnd.openxmlformats-officedocument.presentationml.slide
.docx   application/vnd.openxmlformats-officedocument.wordprocessingml.document
.dotx   application/vnd.openxmlformats-officedocument.wordprocessingml.template
.xlsm   application/vnd.ms-excel.addin.macroEnabled.12
.xlsb   application/vnd.ms-excel.sheet.binary.macroEnabled.12

*/

export class UploadFile extends Field {
  constructor(field) {
    super(field);
    const attr = ["fileLimitType"];
    cr.each(attr, d => {
      this[d] = field[d];
    });
    this.displaySelectType = "FILE";
    this.value = null;
    this.size =
      this.fileLimitType === "IMG" ? 1024 * 1024 * 2 : 1024 * 1024 * 100;
    this.error.size = false;
    this.messages.required = "请上传" + this.displayName;
    this.messages.pattern = "上传文件格式错误";
    this.messages.size = `上传文件大小不能超过${
      this.fileLimitType === "IMG" ? "2M" : "100M"
    }`;
    this.fileUrl = SURL.template.api.ungateway.contentUrl + "?mappingId=";
    this.isUpload = false;
    this.init();
  }

  initAccept() {
    this.accept = "image/*";
    if (this.fileLimitType !== "IMG") {
      const fileAccept = [
        "application/*",
        "application/msword",
        "application/xhtml+xml",
        "application/xml-dtd",
        "application/vnd.ms-project",
        "application/vnd.ms-powerpoint",
        "application/vnd.ms-works",
        "application/vnd.ms-excel",
        "allpication/vnd.ms-asf",
        "application/vnd.ms-pki.stl",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/zip,application/x-zip,application/x-zip-compressed",
        ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
        "image/*",
        "image/vnd.adobe.photoshop",
        "image/vnd.svf",
        "image/vnd.dwg",
        "image/vnd.dxf",
        "text/*",
        "text/xml, application/xml",
        "text/plain",
        "audio/*",
        "video/*"
      ];
      this.accept = fileAccept.join(",");
    }
  }

  init() {
    this.initAccept();
    this.hasError();
    this.isError();
  }

  convertFormData(config) {
    const fd = new FormData();
    cr.each(config, (d, o) => {
      fd.append(o, d);
    });
    return fd;
  }

  setValue(o) {
    this.value = o || null;
    this.dirty = true;
    this.hasError();
    this.isError();
  }

  clearValue() {
    this.setValue(null);
  }

  initValue(val) {
    this.setValue(val);
    this.dirty = false;
  }

  hasError() {
    this.setError();
    if (!this.value && parseInt(this.required) === 1) {
      this.error.required = true;
    }
  }

  isFormatAndSize(file) {
    this.setError();
    this.dirty = true;
    if (this.fileLimitType === "IMG") {
      if (!/(.jpg|.png|.gif|.ps|.jpeg)$/i.test(file.name)) {
        this.error.pattern = true;
      }
    }
    if (file.size > this.size) {
      this.error.size = true;
    }
    this.isError();
  }

  upload(o) {
    if (this.invalid) {
      return;
    }
    let fd = this.convertFormData(o);
    this.isUpload = true;
    api.upload(fd).subscribe(data => {
      this.isUpload = false;
      if (parseInt(data.result) === 0) {
        this.setValue({
          fileName: data.content.name,
          mapId: data.content.mappingId,
          mappingId: data.content.mappingId,
          newPath: data.content.newPath
        });
      }
    });
  }
}
